import React from 'react';
import styled from 'styled-components';
import { LinkButton } from './Button';

const StyledCenter = styled.div``;

export const Center: React.FC = ({ children }) => {
    return <StyledCenter>{children}</StyledCenter>;
};

export const PageContainer = styled.form`
    padding: 30px;
    height: 100%;
    max-width: 400px;
    margin: auto;
`;

export const Container = styled.div`
    padding: ${(props) => props.theme.spacing.large};
    background-color: ${(props) => props.theme.colors.lightYellow};
    border-radius: ${(props) => props.theme.borderRadius};
    box-shadow: 1px 1px 10px -2px black;

    > * + * {
        margin-top: ${(props) => props.theme.spacing.medium};
    }

    + * {
        margin-top: ${(props) => props.theme.spacing.large};
    }
`;

export const Input = styled.input`
    border-radius: ${(props) => props.theme.borderRadius};
    padding: ${(props) => props.theme.spacing.small};
    display: block;
    width: 100%;
`;

export const StyledLinkButton = styled(LinkButton)`
    width: 100%;
`;

export const H1 = styled.h1`
    font-size: ${(props) => props.theme.fontSizes.h1};
`;

export const H2 = styled.h2`
    font-size: ${(props) => props.theme.fontSizes.h2};
`;

export const ButtonSet = styled.div`
    display: flex;
    > * {
        flex: 1;
        border-radius: 0;
        &:first-child {
            border-top-left-radius: ${(props) => props.theme.borderRadius};
            border-bottom-left-radius: ${(props) => props.theme.borderRadius};
        }
        &:last-child {
            border-top-right-radius: ${(props) => props.theme.borderRadius};
            border-bottom-right-radius: ${(props) => props.theme.borderRadius};
        }
    }
`;

